import type {
  ConsultantCampaignsDto,
  ConsultantUserDto,
  ConsultantUserSearchResponse,
  MarkConsultantRequest,
  ScoutAccessDto,
  SaveScoutAccessRequest,
  SetCampaignDemoResponse,
  SetExpressLinkCodeRequest,
} from '@signalvote/shared';
import type { ApiClient } from '../client';

export function createAdminEndpoints(client: ApiClient) {
  return {
    // Campaigns (platform-admin campaign administration)
    campaigns: {
      // Demo mode (ADR-056): platform-admin-only set/unset of a campaign's IsDemo flag.
      // POST /api/admin/campaigns/{id}/demo — 403 for any non-platform-admin (incl. owners).
      setDemo: (campaignId: string, isDemo: boolean) =>
        client.post<SetCampaignDemoResponse>(
          `/api/admin/campaigns/${campaignId}/demo`,
          { isDemo }
        ),
      // PUT replaces the whole allowlist and 409s on a stale concurrencyVersion.
      getScoutAccess: (campaignId: string) =>
        client.get<ScoutAccessDto>(`/api/admin/campaigns/${campaignId}/assistant-access`),
      updateScoutAccess: (campaignId: string, body: SaveScoutAccessRequest) =>
        client.put<ScoutAccessDto>(`/api/admin/campaigns/${campaignId}/assistant-access`, body),
    },

    // Consultants: platform admins find users, mark or unmark them against the Identity concurrency
    // stamp (409 when stale), and list the campaigns each Consultant's Express link created.
    consultants: {
      search: (query: string) =>
        client.get<ConsultantUserSearchResponse>(`/api/admin/users/search?query=${encodeURIComponent(query)}`),
      set: (userId: string, body: MarkConsultantRequest) =>
        client.put<ConsultantUserDto>(`/api/admin/users/${encodeURIComponent(userId)}/consultant`, body),
      list: () => client.get<ConsultantCampaignsDto[]>('/api/admin/consultants'),
      setLinkCode: (userId: string, body: SetExpressLinkCodeRequest) =>
        client.put<ConsultantUserDto>(`/api/admin/users/${encodeURIComponent(userId)}/express-link-code`, body),
    },

    // System
    health: () =>
      client.get<{ status: string; timestamp: string }>('/api/health'),
  };
}
